export default "__VITE_ASSET__B0bMJl8z__"